import { createRouter, createWebHistory } from 'vue-router'

import { generateRoutes } from '@/extensions/langRouter'

const NotFound = () => import('@/views/NotFound.vue')

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('@/views/Home.vue'),
  },
  {
    path: '/a-propos',
    name: 'about',
    component: () => import('@/views/About.vue'),
  },
  {
    path: '/conseils-aux-voyageurs',
    name: 'conseils',
    component: () => import('@/views/Conseils.vue'),
  },
  {
    path: '/soumission-en-ligne',
    name: 'soumission',
    component: () => import('@/views/Soumission.vue'),
  },
  {
    path: '/voyages-etudiants',
    name: 'voyages',
    component: () => import('@/views/Voyages.vue'),
  },
  {
    path: '/voyages/:slug',
    name: 'voyage',
    component: () => import('@/views/Voyage.vue'),
  },
  {
    path: '/plateforme',
    name: 'plateforme',
    component: () => import('@/views/Plateforme.vue'),
  },
  {
    path: '/20ans',
    name: '20ans',
    component: () => import('@/views/TwentiethAnniversary.vue'),
  },
  {
    path: '/conditions-generales',
    name: 'conditions',
    component: () => import('@/views/Conditions.vue'),
  },
  {
    path: '/politique-utilisation',
    name: 'politique',
    component: () => import('@/views/Politique.vue'),
  },
  {
    path: '/404',
    name: 'not-found',
    component: NotFound,
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'catch-all',
    component: NotFound,
  },
]

const localizedRoutes = generateRoutes(routes, 'fr', 'en')

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  linkActiveClass: '-active',
  linkExactActiveClass: '-exact-active',
  routes: localizedRoutes,
  scrollBehavior(to) {
    if (to.hash) {
      return { el: to.hash, behavior: 'smooth' }
    }
  },
})

export default router
